<template>
  <tags v-if="isEditable || convo.meta.tags.length"
  v-bind:tags="convo.meta.tags" 
  v-bind:isEditable="isEditable"
  v-bind:model="convo"
  v-on:addTag="addConvoTag()"
  v-on:removeTag="removeConvoTag($event)"
  />
</template>

<script>
  import ConvoTags from "./ConvoTags.ts";

  export default ConvoTags;
</script>
